import { render, staticRenderFns } from "./EventClone.vue?vue&type=template&id=4477ffcb&"
import script from "./EventClone.vue?vue&type=script&lang=js&"
export * from "./EventClone.vue?vue&type=script&lang=js&"
import style0 from "./EventClone.vue?vue&type=style&index=0&id=4477ffcb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports